import axios from "axios";

const state = {
  tardanzas:[],
  pagination: {},
  totalRoutes: 0,
  totalTardies: 0,
  percentageTardies: 0,
  priceDiscount: [] 
};

const mutations = {
  SET_PRICE_DISCOUNT: (state,data) => {
    state.priceDiscount = data
  },
  SET_TARDANZAS: (state,tardanzas) => {
    state.tardanzas = tardanzas
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination
  },
  SET_TOTAL_ROUTES(state,totalRoutes){
    state.totalRoutes = totalRoutes
  },
  SET_TOTAL_TARDIES(state,totalTardies){
    state.totalTardies = totalTardies
  },
  SET_PERCENTAGE_TARDIES(state,percentageTardies){
    state.percentageTardies = percentageTardies
  }
};

const actions = {
  async GET_TARDANZAS(context, data){
    try {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      const  response = await axios.get( `${endpoint}/routes/?page=` + data.page,{
        params: data
      })
      const tardies = response.data.payload.results
      context.commit('SET_TARDANZAS', tardies.data)
      context.commit('SET_PAGINATION', {
        page: tardies.page,
        first_page_url: null,
        from: tardies.from,
        last_page: tardies.lastPage,
        last_page_url: null,
        next_page_url: null,
        path: null,
        rowsPerPage: tardies.perPage,
        prev_page_url: null,
        to: tardies.to,
        totalItems: tardies.total,
      })
       context.commit('SET_TOTAL_ROUTES', tardies.extra.totalNormalRoutes)
      context.commit('SET_TOTAL_TARDIES', tardies.extra.totalTardies)
      context.commit('SET_PERCENTAGE_TARDIES', tardies.extra.tardiesPercentage)
    }catch (e) {
      console.log(e)
    }
  },
  async GET_PRICE_DISCOUNT(context){
    try {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      const  response = await axios.get( `${endpoint}/tardies-amounts`)
      context.commit('SET_PRICE_DISCOUNT', response.data.payload.results)
    }catch (e) {
      console.log(e)
    }
  }
};

export default {
  namespaced:true,
  state,
  mutations,
  actions
}
